<template>
    <v-menu
        v-model="menuDataInput"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="290px"
        :disabled="disabled"
    >
        <template v-slot:activator="{ on }">
        <v-text-field
            :value="dateFormatted"
            color="black"
            :label="label"
            :prepend-inner-icon="prependInnerIcon"
            :prepend-icon="prependIcon"
            readonly
            clearable
            hide-details
            v-on="on"
            :disabled="disabled"
            @click:clear="clearDate"
        ></v-text-field>
        </template>
        <v-date-picker
          v-model="date"
          locale="pt-br"
          @input="menuDataInput = false; $emit('dataSelecionada', date); dataSelecionadaFn(date)" dark>
          </v-date-picker>
    </v-menu>
</template>

<script>
  import moment from 'moment'
    export default {
        props: {
            data: {
                type: String,
                default: null
            },
            dataSelecionadaFn: {
              type: Function,
              default: ()=>{}
            },
            label: {
                type: String,
                default: "Informe a Data"
            },
            prependInnerIcon: {
                type: String,
                default: ""
            },
            prependIcon: {
                type: String,
                default: ""
            },
            soloInverted: {
                type: Boolean,
                default: true
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                date: this.data,
                menuDataInput: false
            };
        },
        methods: {
          clearDate () {
            this.$emit('dataSelecionada', '');
            this.date = "";
          }
        },
        computed: {
          dateFormatted () {
            moment.locale('pt-BR');
            return this.data ? moment(this.data).format('dddd, DD/MM/YYYY') : ''
          },
        },
        updated() {
          this.$emit('dataSelecionada', this.data);
        }
    };
</script>

<style>
</style>
